export class ListTargetCompaniesRequest {
    _workerId;
    _machineId;
    _documentId;

    constructor() {
        this._workerId = undefined;
        this._machineId = undefined;
        this._documentId = undefined;
    }

    setWorkerId(workerId) {
        this._workerId = workerId;
    }

    setMachineId(machineId) {
        this._machineId = machineId;
    }

    setDocumentId(documentId) {
        this._documentId = documentId;
    }

    body() {
        if ( this._workerId ) {
            return { worker_id: this._workerId };
        }
        if ( this._machineId ) {
            return { machine_id: this._machineId };
        }
        if ( this._documentId ) {
            return { document_id: this._documentId };
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/card/ws/ListTargetCompaniesRequest.js